'use strict';

function enabled(value) {
  if (value === true || value === 1) return true;
  return ['1', 'true', 'yes', 'on'].indexOf(String(value == null ? '' : value).trim().toLowerCase()) !== -1;
}

function managed(connection) {
  return connection && Number(connection.managed) === 1;
}

function managedReady(connection) {
  return managed(connection) && Number(connection.managedReady) === 1 && enabled(connection.enabled);
}

function connectionChoices(connections, options) {
  var records = connections || [];
  var opts = options || {};
  var managedRecords = records.filter(managed);
  var readyCount = managedRecords.filter(managedReady).length;
  var choices = [];
  if (managedRecords.length) {
    choices.push({
      value: 'managed',
      kind: 'managed',
      label: 'Cloud-managed profiles — ' + readyCount + ' ready of ' + managedRecords.length,
    });
  }
  if (opts.includeManagedProfiles) {
    managedRecords.filter(managedReady).forEach(function (connection) {
      choices.push({
        value: connection['@rid'],
        kind: 'managed-profile',
        label: connection.name + ' — ' + connection.localVmac,
      });
    });
  }
  records.filter(function (connection) {
    return !managed(connection) && enabled(connection && connection.enabled);
  }).forEach(function (connection) {
    choices.push({
      value: connection['@rid'],
      kind: 'user',
      label: connection.name + ' — ' + connection.localVmac,
    });
  });
  return choices;
}

function requestUrl(choice) {
  if (choice === 'managed') return '/api/v1/bacnetscconnection/discover-managed';
  return '/api/v1/bacnetscconnection/' + String(choice || '').replace(/^#/, '') + '/discover';
}

function outcomeLabel(outcome) {
  if (outcome === 'completed') return 'Completed';
  if (outcome === 'unready') return 'Skipped — unready';
  if (outcome === 'disabled') return 'Skipped — disabled';
  if (outcome === 'failed') return 'Failed';
  return outcome || 'Unknown';
}

function deviceActionLabel(action) {
  if (action === 'created') return 'Created';
  if (action === 'elsewhere') return 'Configured elsewhere';
  return 'Already matched';
}

function normalizeVmac(value) {
  var text = String(value == null ? '' : value).trim().replace(/[:-]/g, '').toLowerCase();
  return /^[0-9a-f]{12}$/.test(text) ? text : '';
}

function formatVmac(value) {
  var normalized = normalizeVmac(value);
  return normalized ? normalized.match(/.{2}/g).join(':').toUpperCase() : String(value || '');
}

function availableVmacChoices(candidates, currentVmac) {
  var choices = (candidates || []).filter(function (candidate) {
    return normalizeVmac(candidate && candidate.vmac);
  }).map(function (candidate) {
    var count = Number(candidate.deviceCount) || 0;
    var assignedCount = Number(candidate.assignedGatewayCount) || 0;
    var peerDeviceId = Number(candidate.peerDeviceId);
    var peerName = String(candidate.peerName == null ? '' : candidate.peerName).trim();
    var peerIdentity = '';
    if (peerName) {
      peerIdentity = ' — ' + peerName;
      if (Number.isInteger(peerDeviceId) && peerDeviceId >= 0 && peerDeviceId <= 4194303) {
        peerIdentity += ' (Device ' + peerDeviceId + ')';
      }
    } else if (Number.isInteger(peerDeviceId) && peerDeviceId >= 0 && peerDeviceId <= 4194303) {
      peerIdentity = ' — Device ' + peerDeviceId;
    }
    var assignment = assignedCount ? '' : ' · unused';
    return {
      name: formatVmac(candidate.vmac) + peerIdentity + ' — ' + count + ' device' +
        (count === 1 ? '' : 's') + assignment,
      value: normalizeVmac(candidate.vmac),
    };
  });
  var current = normalizeVmac(currentVmac);
  if (current && !choices.some(function (choice) { return choice.value === current; })) {
    choices.unshift({ name: formatVmac(current) + ' — current selection', value: current });
  }
  return choices;
}

function singleAvailableVmac(candidates, currentVmac) {
  if (normalizeVmac(currentVmac)) return '';
  var vmacs = (candidates || []).map(function (candidate) {
    return normalizeVmac(candidate && candidate.vmac);
  }).filter(Boolean).filter(function (vmac, index, all) {
    return all.indexOf(vmac) === index;
  });
  return vmacs.length === 1 ? vmacs[0] : '';
}

function hubStatus(connection) {
  var record = connection || {};
  if (managed(record) && Number(record.managedReady) !== 1) return 'unready';
  if (!enabled(record.enabled)) return 'disabled';
  return record.connectionState || 'unknown';
}

function hubStatusLabel(connection, stateOverride) {
  var record = connection || {};
  var state = String(stateOverride || hubStatus(record));
  if (state !== 'connected') return state;

  var activeHub = String(record.activeHub || '').trim();
  if (activeHub && activeHub === String(record.primaryHubUrl || '').trim()) {
    return 'Connected to primary hub';
  }
  if (activeHub && activeHub === String(record.failoverHubUrl || '').trim()) {
    return 'Connected to failover hub';
  }
  return 'Connected to hub';
}

module.exports = {
  enabled: enabled,
  managed: managed,
  managedReady: managedReady,
  connectionChoices: connectionChoices,
  requestUrl: requestUrl,
  outcomeLabel: outcomeLabel,
  deviceActionLabel: deviceActionLabel,
  availableVmacChoices: availableVmacChoices,
  singleAvailableVmac: singleAvailableVmac,
  hubStatus: hubStatus,
  hubStatusLabel: hubStatusLabel,
};
